<!DOCTYPE html>
<!--
	TODO:
		left pane navigation (use components if possible)
			Admin (target 20200712)
				Create users (see Register)
					- Partially done, migrate to use Firebase Admin + FCF
				(using Admin SDK+FCF) Disable user
			Encoders (target 20200718)
				Create entry (metadata)
					- Company Name
					- data - map
					- dateCreated
					- userId
					- type -> to follow for purpose
		main content
			Admin
				list of users (activate/deactivate)
					- list OK
					- activate/deactivate - to follow
			Encoders
				list of entries made by userId
-->
<template>
	<main id="main-content" class="container py-4">
		<create-doc/>
	</main>
</template>
<style lang="scss" scoped>
</style>
<script>
	import firebase from "firebase/compat/app";
	import "firebase/compat/auth";
	import "firebase/compat/firestore";
	import QRCode from "qrcode";
	import CreateDocument from "@/components/create-document";
	
	class Document {
		constructor() {
		
		}
	}
	var documentConverter = {
		toFirestore: function(document) {
			return {
				companyName: document.companyName,
				createdDate: document.createdDate,
				metadata: document.metadata,
			}
		},
		fromFirestore: function(snapshot, options) {
			const data = snapshot.data(options);
			var document = new Document();
				document.companyName = data.companyName;
				document.createdDate = data.createdDate.toDate().toLocaleDateString("en-US");
				document.metadata = data.metadata;
			return document;
		}
	}
	export default {
		methods: {
			addDataToMap() {
				this.data[this.data_key] = this.data_value;
				this.data_key = "";
				this.data_value = "";
			},
			createDocument() {
				var document = new Document();
				document.companyName = this.companyName;
				document.createdDate = new Date();
				document.metadata = this.data;
				firebase.firestore().collection("Documents")
					.doc(firebase.auth().currentUser.uid).collection("Metadata")
					.withConverter(documentConverter).add(document).then(docResult => {
						//cannot use Firebase ML Kit to create QR code
						// only available in Android, iOS.
						//Use web-based dependencies for this

						/*
						QRCode.toCanvas(canvasElement, docResult.id, error => {
							if (error) {
								console.error("" + error);
							}
							console.log("successfully generated image");
						});
						*/
						QRCode.toDataURL(docResult.id, (error, url) => {
							if (error) {
								console.error(error);
							}

							var canvasElement = this.$refs.document_result;
							var canvasContext = canvasElement.getContext("2d");
							var img = new Image;
							img.onload = () => {
								canvasContext.drawImage(img, 0, 0);
							};
							img.src = url;
						});
						this.getUsersDocuments();
					});
			},
		},
		components: {'create-doc': CreateDocument},
		data() {
			return {
				uid: "",
				firstName: "",
				middleName: "",
				lastName: "",
				birthdate: null,
				fullAddress: "",
				prcId: "",
				email: "",
				password: "",
				confirmPassword: "",
				role: -1,
				error: "",
				
				
				docList: [],
				companyName: "",
				data: {},
				data_key: "",
				data_value: "",
				
				perPage: 5,
				currentPage: 1
			}
		},
		computed: {
			rows() {
				return this.docList.length;
			}
		}
	}
</script>

